import { render, staticRenderFns } from "./daily-office-today.vue?vue&type=template&id=91d40570&scoped=true"
import script from "./daily-office-today.vue?vue&type=script&lang=js"
export * from "./daily-office-today.vue?vue&type=script&lang=js"
import style0 from "./daily-office-today.vue?vue&type=style&index=0&id=91d40570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d40570",
  null
  
)

export default component.exports